<template>
  <nav aria-label="breadcrumb" class="event-breadcrumb flex justify-between items-center p-4">
    <div ref="breadcrumbWrapper" class="event-breadcrumb-wrapper">
      <ul class="flex">
        <!-- Full breadcrumb if content fits within the wrapper -->
        <li v-for="(crumb, index) in visibleBreadcrumbs" :key="index" class="event-breadcrumb-item text-gray-500">
          <router-link :to="crumb.to" v-if="crumb.to && index < breadcrumbList.length - 1"
            class="text-blue-gray-900 hover:text-light-blue-500 text-sm">
            {{ crumb.text }}
          </router-link>
          <span v-else class="text-sm font-bold">
            {{ crumb.text }}
          </span>
          <!-- Separator for Breadcrumbs -->
          <span v-if="index < visibleBreadcrumbs.length - 1" class="mx-1 text-sm font-semibold text-blue-gray-400">/</span>
        </li>

        <!-- Ellipsis for overflow -->
        <li v-if="!isContentFit && breadcrumbList.length > 2" class="event-breadcrumb-item">
          <span class="text-sm text-gray-500">...</span>
        </li>
      </ul>
    </div>
  </nav>
</template>




<script>
import { defineComponent, ref, onMounted, onBeforeUnmount, computed } from 'vue';

export default defineComponent({
  name: 'HeaderBreadcrumb',
  props: {
    breadcrumbList: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const breadcrumbWrapper = ref(null);
    const isContentFit = ref(true); // State to track if breadcrumbs fit within the container

    // Function to check if the breadcrumb content fits within the wrapper
    const checkContentFit = () => {
      if (breadcrumbWrapper.value) {
        isContentFit.value = breadcrumbWrapper.value.scrollWidth <= breadcrumbWrapper.value.clientWidth;
      }
    };

    // Use ResizeObserver to detect changes in size of the breadcrumb wrapper
    let resizeObserver;
    onMounted(() => {
      if (breadcrumbWrapper.value) {
        resizeObserver = new ResizeObserver(checkContentFit);
        resizeObserver.observe(breadcrumbWrapper.value);
        checkContentFit(); // Initial check
      }
    });

    // Clean up observer on component unmount
    onBeforeUnmount(() => {
      if (resizeObserver && breadcrumbWrapper.value) {
        resizeObserver.unobserve(breadcrumbWrapper.value);
      }
    });

    // Computed property to return visible breadcrumbs
    const visibleBreadcrumbs = computed(() => {
      if (isContentFit.value || props.breadcrumbList.length <= 2) {
        return props.breadcrumbList; // Show full list when content fits
      } else {
        // Return only the first and last breadcrumbs when content doesn't fit
        return [
          props.breadcrumbList[0],
          props.breadcrumbList[props.breadcrumbList.length - 1]
        ];
      }
    });

    return {
      breadcrumbWrapper,
      isContentFit,
      visibleBreadcrumbs
    };
  }
});
</script>



<style scoped>
.event-breadcrumb {
  width: 100%;
  padding: 0.5rem 1rem;  
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.event-breadcrumb ul {
    list-style: none;
    display: flex;
}

.event-breadcrumb-wrapper {
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}

.event-breadcrumb-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 75%;
}

.event-breadcrumb-item::after {
    content: '';
}

@media (min-width: 768px) {
  .event-breadcrumb-item {
    max-width: none; 
  }
}

@media (max-width: 767px) {
  .event-breadcrumb-item {
    max-width: 75%; 
  }
}
</style>